export default __webpack_public_path__ + "static/media/CU4EB8.5c2e05fb.jpg";